import { all, call, put, takeLatest } from "redux-saga/effects";
import { getCallQueueReportByRecordNameErrorAction, getCallQueueReportByRecordNameSuccessAction, getCallQueueReportErrorAction, getCallQueueReportSuccessAction } from "../../actions/callQueueReportAction";
import { Types } from "../../types";
import { GetQueueCallReportResponse } from "../../types/callQueueReport/apiRequestType";
import { getCallQueueReport, getCallQueueReportByRecordName } from "../apiRequests/callQueueReport";
import { getCallRating, setCallRating } from "../apiRequests/callRatingRequest";
import { getCallRatingErrorAction, getCallRatingSuccessAction, setCallRatingErrorAction, setCallRatingSuccessAction } from "../../actions/callRatingAction";



function* getCallRatingHandler(action: any) {
    try {
        const response: { data: GetQueueCallReportResponse } = yield call(getCallRating, action.payload.customerLineId)
        yield put(
            getCallRatingSuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            getCallRatingErrorAction({
                error: error
            })
        )
    }
}



function* setCallRatingHandler(action: any) {
    try {
        const response: { data: any } = yield call(setCallRating, action.payload.params)
        yield put(
            setCallRatingSuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            setCallRatingErrorAction({
                error: error
            })
        )
    }
}

function* callRatingSaga() {
    yield all([takeLatest(Types.GET_CALL_RATING_REQUEST, getCallRatingHandler)]);
    yield all([takeLatest(Types.SET_CALL_RATING_REQUEST, setCallRatingHandler)]);
}

export default callRatingSaga